<template>
  <div class="tabs_content" id="tab-2">
    <Settings
        :isEditable="isEditable"
        :entity="entity"
        ref="settingsRef"
    />
    <Actions
        :isEditable="isEditable"
        :entity="entity"
        :broadcast-names="broadcastNames"
        @broadcast-search-modal="$emit('broadcast-search-modal', arguments[0])"
        @broadcast-search-input="$emit('broadcast-search-input', arguments[0])"
    />
    <DeviceGroupType
        :isEditable="isEditable"
        :entity="entity"
        @input="recalcRecipients"
    />
    <Message
        :isEditable="isEditable"
        :entity="entity"
        :is-update="isUpdate"
        ref="messageRef"
        @selectedLanguageChange="onSelectedLanguageChange"
    />
    <Recipients
        :isEditable="isEditable"
        :entity="entity"
        :is-update="isUpdate"
        ref="recipientsRef"
    />
  </div>
</template>

<script>

import Recipients from "../Forms/Recipients.vue";
import Settings from "../Forms/Settings.vue";
import DeviceGroupType from "../Forms/DeviceGroupType.vue";
import Message from "../Forms/Message.vue";
import Actions from "../Forms/Actions.vue";

export default {
  name: "AdvertisingBannerDetailSettings",
  components: {Actions, Message, DeviceGroupType, Settings, Recipients},
  props: {
    isEditable: Boolean,
    isUpdate: Boolean,
    entity: Object,
    broadcastNames: Object,
  },
  methods:{
    recalcRecipients(){
      this.$refs['recipientsRef'].onRecipientsChange();
    },
    onSelectedLanguageChange(selectedLanguage){
      this.$emit('selectedLanguageChange', selectedLanguage)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Detail/Settings.vue